// import React, { useState, useEffect } from "react";
// import { Tabs, Card, Row, Col, Spin, Collapse, Table } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import { fetchEnrollmentPolicyType, getTopTenClaimAmountReport } from "../../Action/Actions";
// import { useSelectedYear } from "../../Context/SelectYearContext";
// import { getUserData } from "../login/LoginSlice";
// import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
// import "./Report.css";

// const TopTenClaims = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { module_option_ids } = location.state || {};
//   const AuthData = useSelector(getUserData);
//   const [activeTab, setActiveTab] = useState("GMC");
//   const [selectedPolicy, setSelectedPolicy] = useState(null);
//   const { selectedYear } = useSelectedYear();
//   const [policyTypeData, setPolicyTypeData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [topTenClaimData, setTopTenClaimData] = useState([]);
//   const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
//   const policyTypes = Object.keys(policyTypeData || {});
//   const user = useSelector(getUserData);

//   useEffect(() => {
//     if (AuthData?.corporate_id) {
//       setLoading(true);
//       dispatch(fetchEnrollmentPolicyType(AuthData?.corporate_id))
//         .then((response) => {
//           const policyTypeList = response?.policy_type_list || {};
//           setPolicyTypeData(policyTypeList);
//           const firstPolicy = policyTypeList[activeTab]?.[0];
//           setSelectedPolicy(firstPolicy || null);
//           setLoading(false);
//         })
//         .catch((err) => {
//           setLoading(false);
//           console.error("Error fetching policy type:", err);
//         });
//     }
//   }, [dispatch, AuthData, activeTab]);

//   useEffect(() => {
//     if (selectedPolicy) {
//       setLoading(true);
//       dispatch(getTopTenClaimAmountReport(selectedPolicy.policy_id))
//         .then((data) => {
//           setTopTenClaimData(data);
//           setLoading(false);
//         })
//         .catch((err) => {
//           setLoading(false);
//           console.error("Error fetching top ten claim amount report:", err);
//         });
//     }
//   }, [dispatch, selectedPolicy]);

//   const handleTabChange = (key) => {
//     setActiveTab(key);
//     const policy = policyTypeData[key]?.[0];
//     setSelectedPolicy(policy || null);
//   };

//   const handlePolicyNumberClick = (policyNumber) => {
//     const policy = policyTypeData[activeTab]?.find(p => p.policy_number === policyNumber);
//     setSelectedPolicy(policy);
//   };

//   const handleTableChange = (pagination) => {
//     setPagination(pagination);
//   };

//   const top10ClaimColumns = [
//     {
//       title: "SR NO",
//       dataIndex: "srNo",
//       key: "srNo",
//       render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
//     },
//     {
//       title: "HOSPITAL NAME",
//       dataIndex: "hospital_name",
//       key: "hospital_name",
//     },
//     {
//       title: "CLAIM COUNT",
//       dataIndex: "claim_count",
//       key: "claim_count",
//     },
//     {
//       title: "RAISED AMOUNT",
//       dataIndex: "raised_amount",
//       key: "raised_amount",
//     },
//     {
//       title: "AVG. AMOUNT",
//       dataIndex: "avg_amount",
//       key: "avg_amount",
//     },
//     {
//       title: "CITY",
//       dataIndex: "city",
//       key: "city",
//     },
//   ];

//   const totalClaimCount = topTenClaimData.reduce(
//     (total, record) => total + record.claim_count,
//     0
//   );
//   const totalRaisedAmount = topTenClaimData.reduce(
//     (total, record) => total + parseFloat(record.raised_amount.replace(/[^0-9.-]+/g, "")),
//     0
//   );
//   const totalAvgAmount = totalClaimCount
//     ? totalRaisedAmount / totalClaimCount
//     : 0;
//   const totalRow = {
//     key: "total",
//     srNo: "Total",
//     hospital_name: "",
//     claim_count: totalClaimCount,
//     raised_amount: `₹${totalRaisedAmount.toFixed(2)}`,
//     avg_amount: `₹${totalAvgAmount.toFixed(2)}`,
//     city: "",
//   };

//   const data = topTenClaimData.map((item, index) => ({
//     name: item.hospital_name,
//     count: item.claim_count,
//     color: ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF", "#FF4560", "#775DD0", "#00E396", "#FEB019", "#FF4560"][index % 10],
//   }));

//   const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
//     const RADIAN = Math.PI / 180;
//     const radius = 25 + innerRadius + (outerRadius - innerRadius);
//     const x = cx + radius * Math.cos(-midAngle * RADIAN);
//     const y = cy + radius * Math.sin(-midAngle * RADIAN);

//     return (
//       <text x={x} y={y} fill="white" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
//         {`${(percent * 100).toFixed(0)}%`}
//       </text>
//     );
//   };

//   const renderLegend = (props) => {
//     const { payload } = props;
//     return (
//       <div>
//         {payload.map((entry, index) => (
//           <div key={`item-${index}`} className="custom-legend-item">
//             <span style={{ backgroundColor: entry.color, display: 'inline-block', width: '10px', height: '10px', marginRight: '5px' }}></span>
//             <span>{entry.value}</span>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <Spin spinning={loading}>
//       <div className="escalation-matrix-container">
//         <div className="escalation-content">
//           <Row className="escalation-row-header">
//             <span style={{ fontWeight: "700", fontSize: "20px" }}>
//               {user?.fullname || "Guest"}
//             </span>{" "}
//             (Financial Year: {selectedYear})
//           </Row>
//         </div>
//         <Tabs
//           activeKey={activeTab}
//           onChange={handleTabChange}
//           className="esc-tab"
//           items={policyTypes.map((type) => ({
//             key: type,
//             label: type,
//             children: (
//               <>
//                 <Tabs
//                   activeKey={selectedPolicy?.policy_number}
//                   onChange={handlePolicyNumberClick}
//                   items={(policyTypeData[type] || []).map((policy, index) => ({
//                     key: policy.policy_number || `policy-${index}`,
//                     label: policy.policy_number || "",
//                   }))}
//                 />
//                 {selectedPolicy && (
//                   <Card>
//                     <Row gutter={16} className="Topten-row" style={{ marginBottom: '16px' }}>
//                       <Col lg={12} md={24} sm={24} xs={24}>
//                         <Card className="claim-card" title="Top 10 Reported Hospital Claim Amount">
//                           <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
//                             <ResponsiveContainer width="100%" height={400}>
//                               <PieChart>
//                                 <Pie
//                                   data={data}
//                                   dataKey="count"
//                                   nameKey="name"
//                                   cx="50%"
//                                   cy="50%"
//                                   outerRadius={160}
//                                   labelLine={false}
//                                   label={renderCustomizedLabel}
//                                 >
//                                   {data.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={entry.color} />
//                                   ))}
//                                 </Pie>
//                                 <Tooltip />
//                                 <Legend
//                                   layout="vertical"
//                                   align="right"
//                                   verticalAlign="middle"
//                                   iconSize={10}
//                                   content={renderLegend}
//                                   width={"45%"}
//                                 />
//                               </PieChart>
//                             </ResponsiveContainer>
//                           </div>
//                         </Card>
//                       </Col>
//                       <Col lg={12} md={24} sm={24} xs={24}>
//                         <Card className="claim-card" title="Top 10 Reported Hospital Paid Claim Amount">
//                           <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
//                             <ResponsiveContainer width="100%" height={400}>
//                               <PieChart>
//                                 <Pie
//                                   data={data}
//                                   dataKey="count"
//                                   nameKey="name"
//                                   cx="50%"
//                                   cy="50%"
//                                   outerRadius={160}
//                                   labelLine={false}
//                                   label={renderCustomizedLabel}
//                                 >
//                                   {data.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={entry.color} />
//                                   ))}
//                                 </Pie>
//                                 <Tooltip />
//                                 <Legend
//                                   layout="vertical"
//                                   align="right"
//                                   verticalAlign="middle"
//                                   iconSize={10}
//                                   content={renderLegend}
//                                   width={"45%"}
//                                 />
//                               </PieChart>
//                             </ResponsiveContainer>
//                           </div>
//                         </Card>
//                       </Col>
//                     </Row>
//                     <Collapse className="custom-collapse" style={{ marginBottom: '16px' }}>
//                       <Collapse.Panel header="Top 10 Reported Hospital Claim Amount" key="1">
//                         <Table
//                           dataSource={[...topTenClaimData, totalRow]}
//                           columns={top10ClaimColumns}
//                           pagination={pagination}
//                           onChange={handleTableChange}
//                         />
//                       </Collapse.Panel>
//                     </Collapse>
//                     <Collapse className="custom-collapse" style={{ marginBottom: '16px' }}>
//                       <Collapse.Panel header="Top 10 Reported Hospital Paid Claim Amount" key="2">
//                         <Card title="Summary of Hospital Claims">
//                           <Table
//                             dataSource={[...topTenClaimData, totalRow]}
//                             columns={top10ClaimColumns}
//                             pagination={pagination}
//                             onChange={handleTableChange}
//                           />
//                         </Card>
//                       </Collapse.Panel>
//                     </Collapse>
//                   </Card>
//                 )}
//               </>
//             ),
//           }))}
//         />
//       </div>
//     </Spin>
//   );
// };

// export default TopTenClaims;







// first version
// import React, { useState, useEffect } from "react";
// import { Tabs, Card, Row, Col, Spin, Collapse, Table } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import { fetchEnrollmentPolicyType, getTopTenClaimAmountReport, getTopTenPaidClaimAmountReport } from "../../Action/Actions";
// // import { useSelectedYear } from "../../Context/SelectYearContext"; // --- REMOVED
// import { selectFinancialYears, selectSelectedYearId } from "../../Redux/financialYearSlice"; // +++ ADDED
// import { getUserData } from "../login/LoginSlice";
// import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
// import "./Report.css";
// import { TeamOutlined, UserOutlined, FileAddOutlined, FireOutlined } from "@ant-design/icons";

// const TopTenClaims = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { module_option_ids } = location.state || {};
//   const AuthData = useSelector(getUserData);

//   // +++ ADDED: Get financial year data from Redux store
//   const selectedYearId = useSelector(selectSelectedYearId);
//   const financialYears = useSelector(selectFinancialYears);

//   // Find the selected year's display name from the year list
//   const selectedYear = financialYears.find(year => year.id === selectedYearId)?.financial_year || "Not Selected";

//   const [activeTab, setActiveTab] = useState("GMC");
//   const [selectedPolicy, setSelectedPolicy] = useState(null);
//   // const { selectedYear } = useSelectedYear(); // --- REMOVED
//   const [policyTypeData, setPolicyTypeData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [topTenClaimData, setTopTenClaimData] = useState([]);
//   const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
//   const policyTypes = Object.keys(policyTypeData || {});
//   const user = useSelector(getUserData);

//   useEffect(() => {
//     // The thunk now gets the financial year ID from the Redux state automatically
//     if (AuthData?.corporate_id && selectedYearId) {
//       setLoading(true);
//       dispatch(fetchEnrollmentPolicyType(AuthData?.corporate_id))
//         .then((response) => {
//           const policyTypeList = response?.policy_type_list || {};
//           setPolicyTypeData(policyTypeList);
//           // When data reloads (e.g., on year change), reset to the first policy of the current active tab
//           const firstPolicy = policyTypeList[activeTab]?.[0];
//           setSelectedPolicy(firstPolicy || null);
//           setLoading(false);
//         })
//         .catch((err) => {
//           setLoading(false);
//           console.error("Error fetching policy type:", err);
//         });
//     }
//     // +++ UPDATED dependency array to react to year changes
//   }, [dispatch, AuthData, selectedYearId]);

//   useEffect(() => {
//      // Clear previous data if no policy is selected
//     if (!selectedPolicy) {
//         setTopTenClaimData([]);
//         return;
//     }

//     if (selectedPolicy && selectedYearId) {
//       setLoading(true);
//       // This action now implicitly uses the financial year ID from the Redux state
//       dispatch(getTopTenClaimAmountReport(selectedPolicy.policy_id))
//         .then((data) => {
//           console.log("Top Ten Claim Data:", data);
//           setTopTenClaimData(data);
//           setLoading(false);
//         })
//         .catch((err) => {
//           setLoading(false);
//           setTopTenClaimData([]); // Clear data on error
//           console.error("Error fetching top ten claim amount report:", err);
//         });
//     }
//     // +++ UPDATED dependency array to react to year changes
//   }, [dispatch, selectedPolicy, selectedYearId]);

//   const handleTabChange = (key) => {
//     setActiveTab(key);
//     // Select the first policy of the newly activated tab
//     const policy = policyTypeData[key]?.[0];
//     setSelectedPolicy(policy || null);
//   };

//   const handlePolicyNumberClick = (policyNumber) => {
//     const policy = policyTypeData[activeTab]?.find(p => p.policy_number === policyNumber);
//     setSelectedPolicy(policy);
//   };

//   const handleTableChange = (pagination) => {
//     setPagination(pagination);
//   };

//   const top10ClaimColumns = [
//     {
//       title: "SR NO",
//       dataIndex: "srNo",
//       key: "srNo",
//       render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
//     },
//     {
//       title: "HOSPITAL NAME",
//       dataIndex: "hospital_name",
//       key: "hospital_name",
//     },
//     {
//       title: "CLAIM COUNT",
//       dataIndex: "claim_count",
//       key: "claim_count",
//     },
//     {
//       title: "RAISED AMOUNT",
//       dataIndex: "raised_amount",
//       key: "raised_amount",
//     },
//     {
//       title: "AVG. AMOUNT",
//       dataIndex: "avg_amount",
//       key: "avg_amount",
//     },
//     {
//       title: "CITY",
//       dataIndex: "city",
//       key: "city",
//     },
//   ];

//   const totalClaimCount = topTenClaimData.reduce(
//     (total, record) => total + record.claim_count,
//     0
//   );
//   const totalRaisedAmount = topTenClaimData.reduce(
//     (total, record) => total + parseFloat(record.raised_amount.replace(/[^0-9.-]+/g, "")),
//     0
//   );
//   const totalAvgAmount = topTenClaimData.reduce(
//     (total, record) => total + parseFloat(record.avg_amount.replace(/[^0-9.-]+/g, "")),
//     0
//   );
//   const totalRow = {
//     key: "total",
//     srNo: "Total",
//     hospital_name: "",
//     claim_count: totalClaimCount,
//     raised_amount: `₹${totalRaisedAmount.toFixed(2)}`,
//     avg_amount: `₹${totalAvgAmount.toFixed(2)}`,
//     city: "",
//   };
//   const getTabIcon = (type) => {
//     switch (type) {
//       case "GMC":
//         return <TeamOutlined style={{ marginRight: 8 }} />;
//       case "GTL":
//         return <UserOutlined style={{ marginRight: 8 }} />;
//       case "GPA":
//         return <TeamOutlined style={{ marginRight: 8 }} />;
//       case "Parent policy":
//         return <TeamOutlined style={{ marginRight: 8 }} />;
//       case "Topup":
//         return <FileAddOutlined style={{ marginRight: 8 }} />;
//       case "Fire":
//         return <FireOutlined style={{ marginRight: 8 }} />;
//       default:
//         return null;
//     }
//   };

//   const data = topTenClaimData.map((item, index) => ({
//     name: item.hospital_name,
//     count: item.claim_count,
//     color: ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF", "#FF4560", "#775DD0", "#00E396", "#FEB019", "#FF4560"][index % 10],
//   }));

//   const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
//     const RADIAN = Math.PI / 180;
//     const radius = 25 + innerRadius + (outerRadius - innerRadius);
//     const x = cx + radius * Math.cos(-midAngle * RADIAN);
//     const y = cy + radius * Math.sin(-midAngle * RADIAN);

//     if (percent > 0.05) {
//       return (
//         <text x={x} y={y} fill="white" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
//           {`${(percent * 100).toFixed(0)}%`}
//         </text>
//       );
//     }
//     return null;
//   };

//   const renderLegend = (props) => {
//     const { payload } = props;
//     return (
//       <div>
//         {payload.map((entry, index) => (
//           <div key={`item-${index}`} className="custom-legend-item">
//             <span style={{ backgroundColor: entry.color, display: 'inline-block', width: '10px', height: '10px', marginRight: '5px' }}></span>
//             <span>{entry.value}</span>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <Spin spinning={loading}>
//       <div className="escalation-matrix-container">
//         <div className="escalation-content">
//           <Row className="escalation-row-header">
//             <span style={{ fontWeight: "700", fontSize: "20px" }}>
//               {user?.corporate_name || "Guest"}
//             </span>{" "}
//             <span style={{ marginLeft: "8px" }}>
//               {/* This now uses the 'selectedYear' variable derived from Redux state */}
//               (Financial Year: {selectedYear})
//             </span>
//           </Row>
//         </div>
//         <Tabs
//           activeKey={activeTab}
//           onChange={handleTabChange}
//           className="esc-tab"
//           items={policyTypes.map((type) => ({
//             key: type,
//             label: (
//               <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//                 {type}
//                 {getTabIcon(type)}
//               </span>
//             ),
//             children: (
//               <>
//                 <Tabs
//                   activeKey={selectedPolicy?.policy_number}
//                   onChange={handlePolicyNumberClick}
//                   items={(policyTypeData[type] || []).map((policy, index) => ({
//                     key: policy.policy_number || `policy-${index}`,
//                     label: policy.policy_number || "",
//                   }))}
//                 />
//                 {selectedPolicy && (
//                   <Card>
//                     <Row gutter={16} className="Topten-row" style={{ marginBottom: '16px' }}>
//                       <Col lg={24} md={24} sm={24} xs={24}>
//                         <Card className="claim-card" title="Top 10 Reported Hospital Claim Amount">
//                           <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
//                             <ResponsiveContainer width="100%" height={400}>
//                               <PieChart>
//                                 <Pie
//                                   data={data}
//                                   dataKey="count"
//                                   nameKey="name"
//                                   cx="50%"
//                                   cy="50%"
//                                   outerRadius={160}
//                                   labelLine={false}
//                                   label={renderCustomizedLabel}
//                                 >
//                                   {data.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={entry.color} />
//                                   ))}
//                                 </Pie>
//                                 <Tooltip />
//                                 <Legend
//                                   layout="vertical"
//                                   align="right"
//                                   verticalAlign="middle"
//                                   iconSize={10}
//                                   content={renderLegend}
//                                   width={"45%"}
//                                 />
//                               </PieChart>
//                             </ResponsiveContainer>
//                           </div>
//                         </Card>
//                       </Col>
//                       <Col lg={24} md={24} sm={24} xs={24}>
//                         <Card className="claim-card" title="Top 10 Reported Hospital Paid Claim Amount">
//                           <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
//                             <ResponsiveContainer width="100%" height={400}>
//                               <PieChart>
//                                 <Pie
//                                   data={data}
//                                   dataKey="count"
//                                   nameKey="name"
//                                   cx="50%"
//                                   cy="50%"
//                                   outerRadius={160}
//                                   labelLine={false}
//                                   label={renderCustomizedLabel}
//                                 >
//                                   {data.map((entry, index) => (
//                                     <Cell key={`cell-${index}`} fill={entry.color} />
//                                   ))}
//                                 </Pie>
//                                 <Tooltip />
//                                 <Legend
//                                   layout="vertical"
//                                   align="right"
//                                   verticalAlign="middle"
//                                   iconSize={10}
//                                   content={renderLegend}
//                                   width={"45%"}
//                                 />
//                               </PieChart>
//                             </ResponsiveContainer>
//                           </div>
//                         </Card>
//                       </Col>
//                     </Row>
//                     <Collapse
//                       className="custom-collapse"
//                       style={{ marginBottom: '16px' }}
//                       defaultActiveKey={['1']}
//                     >
//                       <Collapse.Panel header="Top 10 Reported Hospital Claim Amount" key="1">
//                         <Table
//                           dataSource={[...topTenClaimData, totalRow]}
//                           columns={top10ClaimColumns.map(col => {
//                             if (col.dataIndex === "srNo") {
//                               return {
//                                 ...col,
//                                 render: (text, record, index) =>
//                                   record.key === "total" ? (
//                                     <span style={{ fontWeight: "bold" }}>Total</span>
//                                   ) : (pagination.current - 1) * pagination.pageSize + index + 1,
//                               };
//                             }
//                             return {
//                               ...col,
//                               render: (text, record) =>
//                                 record.key === "total" ? (
//                                   <span style={{ fontWeight: "bold" }}>{text}</span>
//                                 ) : text,
//                             };
//                           })}
//                           pagination={false}
//                           bordered
//                           rowClassName={record => record.key === "total" ? "ant-table-summary-row" : ""}
//                         />
//                       </Collapse.Panel>
//                     </Collapse>
//                     <Collapse
//                       className="custom-collapse"
//                       style={{ marginBottom: '16px' }}
//                       defaultActiveKey={['1']}
//                     >
//                       <Collapse.Panel header="Top 10 Reported Hospital Paid Claim Amount" key="1">
//                           <Table
//                             dataSource={[...topTenClaimData, totalRow]}
//                             columns={top10ClaimColumns.map(col => {
//                               if (col.dataIndex === "srNo") {
//                                 return {
//                                   ...col,
//                                   render: (text, record, index) =>
//                                     record.key === "total" ? (
//                                       <span style={{ fontWeight: "bold" }}>Total</span>
//                                     ) : (pagination.current - 1) * pagination.pageSize + index + 1,
//                                 };
//                               }
//                               return {
//                                 ...col,
//                                 render: (text, record) =>
//                                   record.key === "total" ? (
//                                     <span style={{ fontWeight: "bold" }}>{text}</span>
//                                   ) : text,
//                               };
//                             })}
//                             pagination={false}
//                             bordered
//                             rowClassName={record => record.key === "total" ? "ant-table-summary-row" : ""}
//                           />
//                       </Collapse.Panel>
//                     </Collapse>
//                   </Card>
//                 )}
//               </>
//             ),
//           }))}
//         />
//       </div>
//     </Spin>
//   );
// };

// export default TopTenClaims;

import React, { useState, useEffect } from "react";
import { Tabs, Card, Row, Col, Spin, Collapse, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchEnrollmentPolicyType, getTopTenClaimAmountReport, getTopTenPaidClaimAmountReport } from "../../Action/Actions";
import { selectFinancialYears, selectSelectedYearId } from "../../Redux/financialYearSlice";
import { getUserData } from "../login/LoginSlice";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import "./Report.css";
import { TeamOutlined, UserOutlined, FileAddOutlined, FireOutlined } from "@ant-design/icons";

const RESTRICTED_POLICY_TYPE_IDS = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

const TopTenClaims = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { module_option_ids } = location.state || {};
  const AuthData = useSelector(getUserData);

  const selectedYearId = useSelector(selectSelectedYearId);
  const financialYears = useSelector(selectFinancialYears);
  const selectedYear = financialYears.find(year => year.id === selectedYearId)?.financial_year || "Not Selected";

  const [activeTab, setActiveTab] = useState("");
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [policyTypeData, setPolicyTypeData] = useState({});
  const [loading, setLoading] = useState(false);
  const [topTenClaimData, setTopTenClaimData] = useState([]);
  // +++ ADDED: New state for paid claims data
  const [topTenPaidClaimData, setTopTenPaidClaimData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const policyTypes = Object.keys(policyTypeData || {});
  const user = useSelector(getUserData);

  useEffect(() => {
    const fetchPolicyData = async () => {
      if (!AuthData?.corporate_id || !selectedYearId) {
        setLoading(false);
        setPolicyTypeData({});
        setSelectedPolicy(null);
        return;
      }
      try {
        setLoading(true);
        const response = await dispatch(fetchEnrollmentPolicyType(AuthData?.corporate_id));
        const policyTypeList = response?.policy_type_list || {};
        
        // NEW: Filter out restricted policy types
        const filtered_policyTypeList = {};
        for (const type in policyTypeList) {
          const typeName = String(type).toLowerCase();
          if (typeName.includes('marine') || typeName.includes('fire')) {
            continue;
          }

          const policies = policyTypeList[type] || [];
          const validPolicies = policies.filter(p => {
            const details = Array.isArray(p.policy_details) ? p.policy_details[0] : p.policy_details;
            const typeId = details?.policy_type_id || p.policy_type_id || p.policy_details?.policy_type_id;
            const isRestrictedId = RESTRICTED_POLICY_TYPE_IDS.includes(Number(typeId));
            return !isRestrictedId;
          });
          if (validPolicies.length > 0) {
            filtered_policyTypeList[type] = validPolicies;
          }
        }

        setPolicyTypeData(filtered_policyTypeList);
        
        // Get policy types that actually have data (not empty arrays)
        const availableTabs = Object.keys(filtered_policyTypeList || {}).filter(
          (tab) => filtered_policyTypeList[tab] && filtered_policyTypeList[tab].length > 0
        );
        
        // Use the first available type that has data
        const tabToUse = availableTabs.length > 0 ? availableTabs[0] : "";
        
        // Update activeTab to the first available type with data
        if (tabToUse && tabToUse !== activeTab) {
          setActiveTab(tabToUse);
        }
        
        const firstPolicy = policyTypeList[tabToUse]?.[0];
        setSelectedPolicy(firstPolicy || null);
      } catch (err) {
        console.error("Error fetching policy type:", err);
        setPolicyTypeData({});
        setSelectedPolicy(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, AuthData?.corporate_id, selectedYearId]);

  useEffect(() => {
    // Clear previous data if no policy is selected
    if (!selectedPolicy) {
      setTopTenClaimData([]);
      setTopTenPaidClaimData([]); // Clear the new state as well
      return;
    }

    if (selectedPolicy && selectedYearId) {
      setLoading(true);

      // +++ UPDATED: Use Promise.all to fetch both reports in parallel
      const reportedPromise = dispatch(getTopTenClaimAmountReport(selectedPolicy.policy_id));
      const paidPromise = dispatch(getTopTenPaidClaimAmountReport(selectedPolicy.policy_id));

      Promise.all([reportedPromise, paidPromise])
        .then(([reportedData, paidData]) => {
          console.log("Top Ten Reported Data:", reportedData);
          setTopTenClaimData(reportedData || []);

          console.log("Top Ten Paid Data:", paidData);
          setTopTenPaidClaimData(paidData || []);
        })
        .catch((err) => {
          console.error("Error fetching top ten claims reports:", err);
          // Clear data on error to avoid showing stale info
          setTopTenClaimData([]);
          setTopTenPaidClaimData([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [dispatch, selectedPolicy, selectedYearId]);


  const handleTabChange = (key) => {
    setActiveTab(key);
    const policy = policyTypeData[key]?.[0];
    setSelectedPolicy(policy || null);
  };

  const handlePolicyNumberClick = (key) => {
    // Find the policy object based on the key (either policy_number or policy-${index})
    const policy = policyTypeData[activeTab]?.find((p, index) => {
      const policyKey = p.policy_number || `policy-${index}`;
      return policyKey === key;
    });
    
    if (policy) {
      setSelectedPolicy(policy);
    }
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const top10ClaimColumns = [
    { title: "SR NO", dataIndex: "srNo", key: "srNo", render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1 },
    { title: "HOSPITAL NAME", dataIndex: "hospital_name", key: "hospital_name" },
    { title: "CLAIM COUNT", dataIndex: "claim_count", key: "claim_count" },
    { title: "AMOUNT", dataIndex: "raised_amount", key: "raised_amount" }, // Changed label for generic use
    { title: "AVG. AMOUNT", dataIndex: "avg_amount", key: "avg_amount" },
    { title: "CITY", dataIndex: "city", key: "city" },
  ];

  // Calculation for REPORTED data table
  const totalReportedClaimCount = (topTenClaimData || []).reduce((total, record) => total + (record.claim_count || 0), 0);
  const totalReportedRaisedAmount = (topTenClaimData || []).reduce((total, record) => total + parseFloat(String(record.raised_amount).replace(/[^0-9.-]+/g, "") || 0), 0);
  const totalReportedRow = { key: "total", srNo: "Total", claim_count: totalReportedClaimCount, raised_amount: `₹${totalReportedRaisedAmount.toFixed(2)}` };

  // +++ ADDED: Calculation for PAID data table
  const totalPaidClaimCount = (topTenPaidClaimData || []).reduce((total, record) => total + (record.claim_count || 0), 0);
  const totalPaidRaisedAmount = (topTenPaidClaimData || []).reduce((total, record) => total + parseFloat(String(record.raised_amount).replace(/[^0-9.-]+/g, "") || 0), 0);
  const totalPaidRow = { key: "total", srNo: "Total", claim_count: totalPaidClaimCount, raised_amount: `₹${totalPaidRaisedAmount.toFixed(2)}` };

  const getTabIcon = (type) => {
    switch (type) {
      case "GMC": return <TeamOutlined style={{ marginRight: 8 }} />;
      case "GTL": return <UserOutlined style={{ marginRight: 8 }} />;
      case "GPA": return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Parent policy": return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Topup": return <FileAddOutlined style={{ marginRight: 8 }} />;
      case "Fire": return <FireOutlined style={{ marginRight: 8 }} />;
      default: return null;
    }
  };

  const colors = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF", "#FF4560", "#775DD0", "#00E396", "#FEB019", "#FF4560"];
  const reportedChartData = (topTenClaimData || []).map((item, index) => ({ name: item.hospital_name, count: item.claim_count, color: colors[index % colors.length] }));
  // +++ ADDED: Data for the second chart
  const paidChartData = (topTenPaidClaimData || []).map((item, index) => ({ name: item.hospital_name, count: item.claim_count, color: colors[index % colors.length] }));

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    if (percent < 0.05) return null;
    const RADIAN = Math.PI / 180;
    const radius = 25 + innerRadius + (outerRadius - innerRadius);
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (<text x={x} y={y} fill="white" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">{`${(percent * 100).toFixed(0)}%`}</text>);
  };

  const renderLegend = (props) => {
    const { payload } = props;
    return (<div>{payload.map((entry, index) => (<div key={`item-${index}`} className="custom-legend-item"><span style={{ backgroundColor: entry.color, display: 'inline-block', width: '10px', height: '10px', marginRight: '5px' }}></span><span>{entry.value}</span></div>))}</div>);
  };

  const renderTable = (dataSource, totalRow) => (
    <Table
      dataSource={[...dataSource, totalRow]}
      columns={top10ClaimColumns.map(col => ({
        ...col,
        render: (text, record) => record.key === "total" ? <span style={{ fontWeight: "bold" }}>{text}</span> : text,
      }))}
      pagination={false}
      bordered
      rowClassName={record => record.key === "total" ? "ant-table-summary-row" : ""}
    />
  );

  return (
    <Spin spinning={loading}>
      <div className="escalation-matrix-container">
        <div className="escalation-content">
          <Row className="escalation-row-header">
            <span style={{ fontWeight: "700", fontSize: "20px" }}>{user?.corporate_name || "Guest"}</span>{" "}
            <span style={{ marginLeft: "8px" }}>(Financial Year: {selectedYear})</span>
          </Row>
        </div>
        {policyTypes.length > 0 ? (
          <Tabs activeKey={activeTab} onChange={handleTabChange} className="esc-tab" items={policyTypes.map((type) => ({
            key: type,
            label: (<span style={{ display: "flex", alignItems: "center", gap: "5px" }}>{type}{getTabIcon(type)}</span>),
            children: (
              <>
                <Tabs activeKey={selectedPolicy ? (selectedPolicy.policy_number || `policy-${policyTypeData[type]?.findIndex(p => p.policy_id === selectedPolicy.policy_id)}`) : undefined} onChange={handlePolicyNumberClick} items={(policyTypeData[type] || []).map((policy, index) => ({ 
                  key: policy.policy_number || `policy-${index}`, 
                  label: policy.policy_number ? (
                    policy.policy_number
                  ) : (
                    <span
                      style={{
                        backgroundColor: "#FFFF00",
                        color: "#000000E0",
                        padding: "2px 8px",
                        fontSize: "12px",
                        fontFamily: '"Plus Jakarta Sans", sans-serif',
                        borderRadius: "4px",
                        display: "inline-block",
                      }}
                    >
                      Policy Number not issued
                    </span>
                  )
                }))} />
                {selectedPolicy && (
                  <Card>
                    <Row gutter={16} style={{ marginBottom: '16px' }}>
                      <Col lg={12} md={24}>
                        <Card className="claim-card" title="Top 10 Reported Hospital Claim Amount">
                          <ResponsiveContainer width="100%" height={400}>
                            <PieChart>
                              <Pie data={reportedChartData} dataKey="count" nameKey="name" cx="50%" cy="50%" outerRadius={150} labelLine={false} label={renderCustomizedLabel}>
                                {reportedChartData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} />)}
                              </Pie>
                              <Tooltip />
                              <Legend layout="vertical" align="right" verticalAlign="middle" iconSize={10} width={"45%"} />
                            </PieChart>
                          </ResponsiveContainer>
                        </Card>
                      </Col>
                      {/* +++ UPDATED: Second chart now uses paidChartData */}
                      <Col lg={12} md={24}>
                        <Card className="claim-card" title="Top 10 Paid Hospital Claim Amount">
                          <ResponsiveContainer width="100%" height={400}>
                            <PieChart>
                              <Pie data={paidChartData} dataKey="count" nameKey="name" cx="50%" cy="50%" outerRadius={150} labelLine={false} label={renderCustomizedLabel}>
                                {paidChartData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} />)}
                              </Pie>
                              <Tooltip />
                              <Legend layout="vertical" align="right" verticalAlign="middle" iconSize={10} width={"45%"} />
                            </PieChart>
                          </ResponsiveContainer>
                        </Card>
                      </Col>
                    </Row>
                    <Collapse className="custom-collapse" style={{ marginBottom: '16px' }} defaultActiveKey={['1']}>
                      <Collapse.Panel header="Top 10 Reported Hospital Claim Amount" key="1">
                        {renderTable(topTenClaimData, totalReportedRow)}
                      </Collapse.Panel>
                    </Collapse>
                    {/* +++ UPDATED: Second table now uses paid data and its total row */}
                    <Collapse className="custom-collapse" defaultActiveKey={['1']}>
                      <Collapse.Panel header="Top 10 Paid Hospital Claim Amount" key="1">
                        {renderTable(topTenPaidClaimData, totalPaidRow)}
                      </Collapse.Panel>
                    </Collapse>
                  </Card>
                )}
              </>
            ),
          }))}
        />
        ) : (
          <Card style={{ marginTop: "20px" }}>
            <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
              <p style={{ fontSize: "16px", fontWeight: "500" }}>No top ten claims data available for {selectedYear}</p>
            </div>
          </Card>
        )}
      </div>
    </Spin>
  );
};

export default TopTenClaims;